module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921065651_T.8b74bd5b.jpg";